import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { Grid } from '@mui/material';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import APIService from '../../../../APIService';
import swal from 'sweetalert';

export const StateCordination = () => {

  const [scfContent, setScfContent] = useState("");

  useEffect(() => {
    APIService.get('state_coordination')
      .then((response) => {
        setScfContent(response.data);
      });
  }, []);

  const handleSubmit = async (e) => {

    e.preventDefault();
    const formData = new FormData();

    formData.append("scf_content", scfContent);

    const response = await APIService.post(formData, 'state_coordination');

    if (response.success) {

      swal("Success", response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then((value) => {
        window.location.href = "/state-coordination";
      });
    } else {
      swal("Failed", response.message, "error");
    }
  }

  return (
    <div>
      <h1>State Co-ordination Forum</h1>

      <form noValidate onSubmit={handleSubmit}>
        {/* <div className="quill"> */}
        <Grid item xs={12}>
          {/* Adding the react-quill rich text editor */}
          <ReactQuill
            style={{ height: 400 }}
            value={scfContent}
            onChange={setScfContent}
          />
        </Grid>
        {/* </div> */}
        <Button style={{ marginTop: 70 }} variant="primary" type="submit">Submit</Button>{' '}
      </form>

    </div>
  );
};
